module.exports = __webpack_public_path__ + "img/cocos_loading.d8fb5eb7.png";